import { CanDeactivateFn } from '@angular/router';

/** A page that may hold work only it has, and asks before it is thrown away. */
export interface ConfirmsLeaving {
  /** True to leave. */
  confirmLeaving(): boolean;
}

/**
 * Asks before leaving the Rules Explorer with a run going or done: its results live only in the
 * page, so leaving loses them. Kept apart from the component so the routes can name it without
 * pulling the page into the main bundle.
 */
export const confirmLeavingRulesExplorer: CanDeactivateFn<ConfirmsLeaving> = (component) =>
  component?.confirmLeaving() ?? true;
